export default __webpack_public_path__ + "static/media/pixel-dl-instagram-story.79ee590e.png";